export function scorePercentage(
    numerator: number,
    denominator: number,
): number {
    let percentage: number;
    try {
        percentage = (1 / denominator) * numerator;
    } catch {
        percentage = 0;
    }
    if (isNaN(percentage)) {
        percentage = 0;
    }
    return percentage;
}
